import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'
import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { RESET_DATA, UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import supplementBulkImportCollection from 'modules/payroll_bundle/store/collections/supplementBulkImports'
import supplementsCollection from 'modules/payroll_bundle/store/collections/supplements'
import SupplementBulkImport from 'modules/payroll_bundle/store/models/SupplementBulkImport'

interface Props {
  store: SupplementsFormStore
}

const DeleteModal = ({ store }: Props) => {
  const { policyPeriodCollection, periodIndex } = usePolicyPeriods()
  const { supplementDispatch, bulkImportToDeleteId, filename } = useBulkImportSupplements()
  const policyPeriod = policyPeriodCollection.at(periodIndex)

  const fetchSupplements = async (policyPeriodId: string) => {
    const supplementData = { policy_period_ids: [policyPeriodId] }

    return Promise.all([supplementsCollection.fetch({ data: supplementData })])
  }

  const deleteImportedSupplements = async () => {
    let supplementIds = []

    supplementIds =
      supplementBulkImportCollection
        .get(bulkImportToDeleteId)
        ?.supplements.map((supplement) => supplement.id) || []

    const { success } = await asyncAction(
      () => {
        const supplementBulkImport = new SupplementBulkImport({})
        return supplementBulkImport.rpc('bulk_destroy', {
          ids: [bulkImportToDeleteId],
        })
      },
      {
        successMessage: i18n.t(
          'payroll_bundle.delete_imported_supplements.delete_modal.deleted_successfully'
        ),
        errorMessage: i18n.t(
          'payroll_bundle.delete_imported_supplements.delete_modal.deletion_unsuccessful'
        ),
      }
    )

    if (success) {
      store.removeForms(supplementIds)

      await fetchSupplements(policyPeriod?.attributes.id)

      supplementDispatch({ type: RESET_DATA })
    }
  }

  const onClose = () => {
    supplementDispatch({
      type: UPDATE_DATA,
      payload: {
        showDeleteModal: false,
      },
    })
  }

  const description = i18n.t(
    'payroll_bundle.delete_imported_supplements.delete_modal.deletion_warning',
    {
      filename: filename,
    }
  )

  return (
    <Modal
      title={i18n.t('payroll_bundle.delete_imported_supplements.delete_modal.title')}
      description={description}
      illustration="delete"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={deleteImportedSupplements} type="primary">
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(DeleteModal)
